/**
 * 인증·데이터 백엔드 팩토리
 *
 * VITE_AUTH_BACKEND로 구현체를 선택하고, 선택된 구현체만 동적 import로
 * 로드한다(선택되지 않은 백엔드의 환경 변수 요구가 기동을 막지 않도록).
 * 앱 수명 동안 하나의 백엔드 인스턴스를 공유한다.
 */

import { getRuntimeEnvVar } from '@/app/services/runtimeEnv';
import type { AppBackend } from './types';

export type * from './types';

export function resolveBackendKind(): string {
  return (
    getRuntimeEnvVar('VITE_AUTH_BACKEND', import.meta.env.VITE_AUTH_BACKEND, 'oidc') ||
    'oidc'
  );
}

let backendPromise: Promise<AppBackend> | null = null;

export function getBackend(): Promise<AppBackend> {
  if (!backendPromise) {
    backendPromise = loadBackend(resolveBackendKind());
    // 로드 실패를 캐시하면 이후 모든 호출이 같은 실패에 갇힌다 — 재시도 허용
    backendPromise.catch(() => {
      backendPromise = null;
    });
  }
  return backendPromise;
}

async function loadBackend(kind: string): Promise<AppBackend> {
  switch (kind) {
    case 'oidc': {
      const { createOidcBackend } = await import('./oidc');
      return createOidcBackend();
    }
    default:
      throw new Error(`알 수 없는 인증/데이터 백엔드: "${kind}" (VITE_AUTH_BACKEND 확인)`);
  }
}
